/* global wagtailConfig */
var BULK_ACTION_PAGE_CHECKBOX_INPUT = '[data-bulk-action-checkbox]';
var BULK_ACTION_SELECT_ALL_CHECKBOX = '[data-bulk-action-select-all-checkbox]';
var BULK_ACTIONS_CHECKBOX_PARENT = '[data-bulk-action-parent-id]';
var BULK_ACTION_FOOTER = '[data-bulk-action-footer]';
var BULK_ACTION_NUM_OBJECTS = '[data-bulk-action-num-objects]';
var BULK_ACTION_NUM_OBJECTS_IN_LISTING = '[data-bulk-action-num-objects-in-listing]';
var checkedState = {
    checkedObjects: new Set(),
    numObjects: 0,
    selectAllInListing: false,
    shouldShowAllInListingText: true
};
/**
 * Utility function to get the appropriate string for display in action bar
 */
function getStringForListing(key) {
    if (wagtailConfig.STRINGS.BULK_ACTIONS[wagtailConfig.BULK_ACTION_ITEM_TYPE]) {
        return wagtailConfig.STRINGS.BULK_ACTIONS[wagtailConfig.BULK_ACTION_ITEM_TYPE][key];
    }
    return wagtailConfig.STRINGS.BULK_ACTIONS.ITEM[key];
}
/**
 * Event listener for the `Select All` checkbox
 */
function onSelectAllChange(e) {
    document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
        el.checked = e.target.checked; // eslint-disable-line no-param-reassign
    });
    var changeEvent = new Event('change');
    document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT).forEach(function (el) {
        if (el.checked !== e.target.checked) {
            // eslint-disable-next-line no-param-reassign
            el.checked = e.target.checked;
            if (e.target.checked) {
                el.dispatchEvent(changeEvent);
            }
            else {
                el.classList.remove('show');
            }
        }
    });
    if (!e.target.checked) {
        // when deselecting all checkbox, simply hide the footer for smooth transition
        checkedState.checkedObjects.clear();
        document.querySelector(BULK_ACTION_FOOTER).classList.add('hidden');
    }
}
/**
 * Event listener for individual checkbox
 */
function onSelectIndividualCheckbox(e) {
    if (checkedState.selectAllInListing)
        checkedState.selectAllInListing = false;
    var prevLength = checkedState.checkedObjects.size;
    if (e.target.checked) {
        checkedState.checkedObjects.add(Number(e.target.dataset.objectId));
    }
    else {
        /* unchecks `Select all` checkbox as soon as one page is unchecked */
        document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
            el.checked = false; // eslint-disable-line no-param-reassign
        });
        checkedState.checkedObjects["delete"](Number(e.target.dataset.objectId));
    }
    var numCheckedObjects = checkedState.checkedObjects.size;
    if (numCheckedObjects === 0) {
        /* when all checkboxes are unchecked */
        document.querySelector(BULK_ACTION_FOOTER).classList.add('hidden');
        document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT).forEach(function (el) { return el.classList.remove('show'); });
    }
    else if (numCheckedObjects === 1 && prevLength === 0) {
        /* when 1 checkbox is checked for the first time */
        document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT).forEach(function (el) {
            el.classList.add('show');
        });
        document.querySelector(BULK_ACTION_FOOTER).classList.remove('hidden');
    }
    if (numCheckedObjects === checkedState.numObjects) {
        /* when all checkboxes in the page are checked */
        document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
            el.checked = true; // eslint-disable-line no-param-reassign
        });
        if (checkedState.shouldShowAllInListingText) {
            document.querySelector(BULK_ACTION_NUM_OBJECTS_IN_LISTING).classList.remove('u-hidden');
        }
    }
    else if (checkedState.shouldShowAllInListingText) {
        document.querySelector(BULK_ACTION_NUM_OBJECTS_IN_LISTING).classList.add('u-hidden');
    }
    if (numCheckedObjects > 0) {
        /* Update text on number of pages */
        var numObjectsSelected = '';
        if (numCheckedObjects === 1) {
            numObjectsSelected = getStringForListing('SINGULAR');
        }
        else {
            if (numCheckedObjects === checkedState.numObjects) {
                numObjectsSelected = getStringForListing('ALL').replace('{0}', numCheckedObjects);
            }
            else {
                numObjectsSelected = getStringForListing('PLURAL').replace('{0}', numCheckedObjects);
            }
        }
        document.querySelector(BULK_ACTION_NUM_OBJECTS).textContent = numObjectsSelected;
    }
}
/**
 * Event listener to select all objects in listing
 */
function onClickSelectAllInListing(e) {
    e.preventDefault();
    checkedState.selectAllInListing = true;
    document.querySelector(BULK_ACTION_NUM_OBJECTS).
        textContent = getStringForListing('ALL_IN_LISTING') + ".";
    document.querySelector(BULK_ACTION_NUM_OBJECTS_IN_LISTING).classList.add('u-hidden');
}
/**
 * Event listener for bulk actions which appends selected ids to the corresponding action url
 */
function onClickActionButton(e) {
    e.preventDefault();
    var url = e.target.getAttribute('href');
    var urlParams = new URLSearchParams(window.location.search);
    if (checkedState.selectAllInListing) {
        urlParams.append('id', 'all');
        var parentElement = document.querySelector(BULK_ACTIONS_CHECKBOX_PARENT);
        if (parentElement) {
            var parentPageId = parentElement.dataset.bulkActionParentId;
            urlParams.append('childOf', parentPageId);
        }
    }
    else {
        checkedState.checkedObjects.forEach(function (objectId) {
            urlParams.append('id', objectId);
        });
    }
    window.location.href = url + "&" + urlParams.toString();
}
/**
 * Adds all event listeners
 */
function addBulkActionListeners() {
    var changeEvent = new Event('change');
    document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT)
        .forEach(function (el) {
        checkedState.numObjects++;
        el.addEventListener('change', onSelectIndividualCheckbox);
    });
    document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
        el.addEventListener('change', onSelectAllChange);
    });
    document.querySelectorAll(BULK_ACTION_FOOTER + " .bulk-action-btn").forEach(function (elem) { return elem.addEventListener('click', onClickActionButton); });
    var selectAllInListingText = document.querySelector(BULK_ACTION_NUM_OBJECTS_IN_LISTING);
    if (selectAllInListingText)
        selectAllInListingText.addEventListener('click', onClickSelectAllInListing);
    else
        checkedState.shouldShowAllInListingText = false;
    document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT)
        .forEach(function (el) {
        if (el.checked) {
            el.dispatchEvent(changeEvent);
        }
    });
}
function rebindBulkActionsEventListeners() {
    // when deselecting all checkbox, simply hide the footer for smooth transition
    document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
        el.checked = false; // eslint-disable-line no-param-reassign
    });
    document.querySelector(BULK_ACTION_FOOTER).classList.add('hidden');
    document.querySelectorAll(BULK_ACTION_SELECT_ALL_CHECKBOX).forEach(function (el) {
        // remove already attached event listener first
        el.removeEventListener('change', onSelectAllChange);
        el.addEventListener('change', onSelectAllChange);
    });
    checkedState.checkedObjects.clear();
    checkedState.numObjects = 0;
    document.querySelectorAll(BULK_ACTION_PAGE_CHECKBOX_INPUT)
        .forEach(function (el) {
        checkedState.numObjects++;
        el.addEventListener('change', onSelectIndividualCheckbox);
    });
}
document.addEventListener('DOMContentLoaded', addBulkActionListeners);
if (window.headerSearch) {
    document.querySelector(window.headerSearch.termInput).addEventListener('search-success', rebindBulkActionsEventListeners);
}
